"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkFlowCertificazioneEnumToJSON = exports.WorkFlowCertificazioneEnumFromJSONTyped = exports.WorkFlowCertificazioneEnumFromJSON = exports.WorkFlowCertificazioneEnum = void 0;
/**
 *
 *
 * 1 = ProcessoAsIs
 *
 * 2 = Processoincrociato
 *
 * 3 = ProcessoInvioEmailCliente
 *
 * 4 = ProcesssoScartatoPerDatiIncompleti
 *
 * 5 = ProcesssoScartatoPerAltreMotivazioni
 * @export
 * @enum {string}
 */
var WorkFlowCertificazioneEnum;
(function (WorkFlowCertificazioneEnum) {
    WorkFlowCertificazioneEnum[WorkFlowCertificazioneEnum["NUMBER_1"] = 1] = "NUMBER_1";
    WorkFlowCertificazioneEnum[WorkFlowCertificazioneEnum["NUMBER_2"] = 2] = "NUMBER_2";
    WorkFlowCertificazioneEnum[WorkFlowCertificazioneEnum["NUMBER_3"] = 3] = "NUMBER_3";
    WorkFlowCertificazioneEnum[WorkFlowCertificazioneEnum["NUMBER_4"] = 4] = "NUMBER_4";
    WorkFlowCertificazioneEnum[WorkFlowCertificazioneEnum["NUMBER_5"] = 5] = "NUMBER_5";
})(WorkFlowCertificazioneEnum = exports.WorkFlowCertificazioneEnum || (exports.WorkFlowCertificazioneEnum = {}));
function WorkFlowCertificazioneEnumFromJSON(json) {
    return WorkFlowCertificazioneEnumFromJSONTyped(json, false);
}
exports.WorkFlowCertificazioneEnumFromJSON = WorkFlowCertificazioneEnumFromJSON;
function WorkFlowCertificazioneEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.WorkFlowCertificazioneEnumFromJSONTyped = WorkFlowCertificazioneEnumFromJSONTyped;
function WorkFlowCertificazioneEnumToJSON(value) {
    return value;
}
exports.WorkFlowCertificazioneEnumToJSON = WorkFlowCertificazioneEnumToJSON;
